import { render, staticRenderFns } from "./ProcessModal.vue?vue&type=template&id=8d8bdfaa&"
import script from "./ProcessModal.vue?vue&type=script&lang=js&"
export * from "./ProcessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports